/**
 * バンドルミックスマッチ検索画面　入力VOクラス
 */
export class KYMW1309InputModel {
  /** 受注コード */
  public orderCode: string = null;
  /** 媒体区分 */
  public mediumType: string = null;
  /** プロモーション区分(B：バンドル、P：ミックスマッチ、T：わくわくポイント、S：セット企画) */
  public promotionDiv: string = null;
  /** プロモーション名称 */
  public promotionName: string = null;
  /** 生協コード */
  public coopCode: string = null;
  /** Ｐコード */
  public pCode: string = null;
  /** 部門コード */
  public classCode: string = null;
}
